import React, { useEffect, useState } from 'react';
import RadioList, { FilterListItem } from '../RadioList';
import { useAuth } from '../../../context/Auth';
import { dispatchService } from '../../../services/central-api/dispatch';
import { FieldValues, Path } from 'react-hook-form';
import FilterDependencyMessage from '../../Filters/FilterDependencyMessage';
import { translate } from '../../../services/translate';

function OccurrenceTypeList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name, actingBodyId }: { name: TName; actingBodyId?: number; }) {
    const { user } = useAuth();
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    async function getOccurrenceTypes(authenticatedUser: AuthenticatedUser) {
        try {
            if ((authenticatedUser.isAdmin || authenticatedUser.permissions.dispatch_manage_all_acting_bodies_occurrences) &&
                !actingBodyId) {
                return;
            }
            const types = await dispatchService.getDropDownOccurrenceTypes(actingBodyId ?? authenticatedUser.actingBodyUnitId);
            setItems(types.map(type => ({ label: type.name, value: type.id })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!user) {
            return;
        }
        getOccurrenceTypes(user);
    }, [user]);

    if ((user?.isAdmin || user?.permissions.dispatch_manage_all_acting_bodies_occurrences) &&
        !actingBodyId) {
        return <FilterDependencyMessage message={translate('selectActingBodyFirst')} />;
    }

    return <RadioList name={name} items={items} clearValue={null} isLoading={isLoading} />;
}

OccurrenceTypeList.getCount = RadioList.getCount;

export default OccurrenceTypeList;
